import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useFetchPayoutBatch(batchId: string | null, poll = false) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading, refetch } = useQuery(
    trpc.payoutBatches.get.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "", id: batchId ?? "" },
      {
        enabled: !!merchant?.id && !!batchId,
        refetchInterval: (query) =>
          poll && query.state.data?.status === "unfunded" ? 5000 : false,
      }
    )
  );

  return {
    batch: data,
    isLoading,
    refetch,
  };
}
